import React, { memo } from "react";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import CardRow from "./cardRow";

const MemoRow = memo(CardRow);

const useStyles = makeStyles((theme) => ({
  gridItem: {
    marginBottom: theme.spacing() * 1.5,
  },
  section: {
    marginBottom: theme.spacing(),
    marginTop: theme.spacing() * 2,
    "&:first-child": {
      marginTop: 0,
    },
  },
  subSection: {
    marginBottom: theme.spacing() * 3,
  },
}));

export default ({
  cards,
  addCard,
  getUpdateMethods,
  isPrint,
  quantities,
  years,
  currencyCaption,
}) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.section}>
        Card Details
        {!isPrint ? (
          <>
            {" "}
            <IconButton onClick={addCard}>
              <AddIcon />
            </IconButton>
          </>
        ) : null}
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.subSection}
      >
        Details for each card you plan to send. Use the "+" above to add a new
        row.
      </Typography>
      <Grid container>
        <Hidden smDown>
          <Grid item md={1} className={classes.gridItem}>
            <Typography component="span">Quantity</Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={1} className={classes.gridItem}>
            <Typography component="span">Year</Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={2} className={classes.gridItem}>
            <Typography component="span">Set Name</Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={1} className={classes.gridItem}>
            <Typography component="span">Card #</Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={!isPrint ? 2 : 3} className={classes.gridItem}>
            <Typography component="span">Player</Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={1} className={classes.gridItem}>
            <Typography component="span">Parallel</Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={1} className={classes.gridItem}>
            <Typography component="span">
              Decl. {currencyCaption} Val
            </Typography>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid item md={2} className={classes.gridItem}>
            <Typography component="span">
              <Link
                className={classes.link}
                to="/evaluate"
                target="_blank"
                title="Will this card gem?"
              >
                Evaluate?
              </Link>
            </Typography>
          </Grid>
        </Hidden>
        {!isPrint ? (
          <Hidden smDown>
            <Grid item md={1} className={classes.gridItem}>
              <Typography component="span">Remove</Typography>
            </Grid>
          </Hidden>
        ) : null}
        {cards.length === 0 ? (
          <Grid item xs={12} className={classes.gridItem}>
            <Typography component="span">
              <em>No cards added</em>
            </Typography>
          </Grid>
        ) : null}
      </Grid>
      {cards.map((card) => (
        <MemoRow
          {...{
            key: card.id,
            quantities,
            years,
            isPrint,
            getUpdateMethods,
            currencyCaption,
            ...card,
            evaluationType:
              card.evaluationType !== undefined
                ? card.evaluationType
                : card.shouldEvaluate
                ? 1
                : 0,
          }}
        />
      ))}
    </>
  );
};
